module.exports = __webpack_public_path__ + "static/media/cotyBanner-desktop-1220x1500@2x.4603ce5b.jpg";